import React, { useState } from "react";
import dayjs from "dayjs";

const CalendarMonth = ({ daysArray, title, availableDates, selectedDate, handleDateClick }) => {
    return (
        <div className="calendar-month">
            <h3 className="calendar-title">{title}</h3>
            <div className="calendar-grid">
                {/* Weekday headers */}
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((weekday) => (
                    <div key={weekday} className="calendar-weekday">
                        {weekday}
                    </div>
                ))}

                {/* Empty cells before first day */}
                {Array.from({ length: daysArray[0].day() }, (_, i) => (
                    <div key={`empty-${i}`} className="calendar-day empty"></div>
                ))}

                {/* Actual dates */}
                {daysArray.map((day) => {
                    const formattedDate = day.format("DD-MM-YYYY");
                    const hasSlots = availableDates.includes(formattedDate);
                    const isSelected = formattedDate === selectedDate;
                    const isPast = day.isBefore(dayjs(), "day");

                    return (
                        <div
                            key={formattedDate}
                            className={`calendar-day ${hasSlots ? "available" : ""} ${isSelected ? "selected" : ""} ${isPast ? "past" : ""}`}
                            onClick={!isPast ? () => handleDateClick(day) : undefined}
                        >
                            {day.date()}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CalendarMonth;
